import Service from './service'
import Vue from 'vue'

export default class AuthService {
  /**
   * Authentifie l'utilisateur
   * @param {string} login
   * @param {string} password
   */
  static async authenticate (login, password) {
    try {
      return await Service.api.post('/auth', {
        login: login,
        password: password,
        auth_type: 'credentials'
      })
    } catch (error) {
      if (error.response) {
        Vue.prototype.$message.error(error.response.data.status.message + ' : login ou mot de passe incorrect', 5)
      } else {
        Vue.prototype.$message.error('Une erreur est survenue, veuillez réessayer', 5)
      }
    }
  }
  /**
   * Renouvelle les tokens à partir d’un refresh_token existants. Utilisé lorsque access_token est expiré.
   * @param {string} refreshToken
   */
  static async renewAccessToken (refreshToken) {
    try {
      return await Service.api.post('/auth', {
        auth_type: 'refresh_token'
      }, {
        headers: Service.getAuthHeader(refreshToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
}
